import ExtractionSheetArticleElementBase from "./extraction-sheet-article-element-base.ts";
import ExtractionArticleElementType
    from "@/pages/takeoff/layouts/extraction/context/models/enums/extraction-article-element-type.ts";
import ExtractionOperation, {
    operationMap
} from "@/pages/takeoff/layouts/extraction/context/models/enums/extraction-operation.ts";
import {
    ExtractionSheetArticle3DElementDto
} from "@/models/interfaces/dtos/extraction/extraction-sheet-article-element-dto.ts";
import ProjectIndicatorsDto from "@/models/interfaces/dtos/indicators/project-indicators-dto.ts";
import IndicatorDto from "@/models/interfaces/dtos/indicators/indicator-dto.ts";

/**
 *  Représente un article qui possède des données venant de la BDD Boomer.
 *  Prends en compte des bâtiments et étages avec des id de type entier.
 *  Nécessite de "traduire" les données venant de la BDD Boomer en données utilisables par l'application.
 *  Cette traduction s'effectue avec l'unicité du nom du bâtiment et de l'étage.
 */
class ExtractionSheetArticle3DElement extends ExtractionSheetArticleElementBase {
    
    _3D: string[];
    
    associatedStoreysIds: number[];
    
    associatedIndicators: IndicatorDto[];
    
    constructor(id: string, parentArticleId: string, associatedStoreysIds: number[], trackedIndicatorDefinition: string, unity: string, _3D: string[], associatedIndicators: IndicatorDto[], operation?: ExtractionOperation) {
        super(id, parentArticleId, ExtractionArticleElementType._3D, trackedIndicatorDefinition, unity, operation);
        this.associatedStoreysIds = associatedStoreysIds;
        this._3D = _3D;
        this.associatedIndicators = associatedIndicators;
        this.elements = associatedIndicators.length;
        this.updateCalculValue();
    }

    static fromDto(dto: ExtractionSheetArticle3DElementDto, id: string, projectIndicatorDto?: ProjectIndicatorsDto) {
        if(projectIndicatorDto == null) throw new Error('ProjectIndicatorsDto is null');
        if(dto.associatedStoreysIds.length === 0) throw new Error(
            `No associated storeys for 3D element ${dto.dataKey} (${dto.associatedStoreysIds.join(', ')})`
        )
        
        const associatedStoreys = projectIndicatorDto.buildings
            .flatMap(b => b.storeys)
            .filter(s => dto.associatedStoreysIds.includes(s.storeyId));
        const indicators = associatedStoreys.flatMap(s => s.indicators).filter(i => i.def.keyName === dto.dataKey);
        const threeD = indicators.map(i => i._3D);
        const unity = indicators.length !== 0 ? indicators[0].def.unity : 'u';
        const element = new ExtractionSheetArticle3DElement(crypto.randomUUID(), id, dto.associatedStoreysIds, dto.dataKey, unity, threeD, indicators, operationMap.find(op => op.label === dto.operation)?.value ?? undefined);
        element.elements = indicators.length;
        element.updateCalculValue();
        return element;
    }

    updateElement(newOperationType: ExtractionOperation) {
        this.operation = newOperationType;
        this.updateCalculValue();
    }
    
    updateCalculValue() {
        switch (this.operation) {
            case ExtractionOperation.COUNT:
                this.value = this._3D.length;
                this.unity = 'u';
                return;
            case ExtractionOperation.SUM:
                this.value = this.associatedIndicators.map(i => i.value).reduce((acc, val) => acc + val, 0);
                this.unity = this.associatedIndicators[0].def.unity;
                return;
            case ExtractionOperation.AVERAGE:
                this.value = this.associatedIndicators.map(i => i.value).reduce((acc, val) => acc + val, 0) / this.associatedIndicators.length;
                this.unity = this.associatedIndicators[0].def.unity;
                return;
            default :
                this.value = 0;
        }
    }
}

export default ExtractionSheetArticle3DElement;